module.exports = __webpack_public_path__ + "static/media/26UNRWA9.c13d10c8.jpg";